import React from "react";
import s from './Contacto.module.css'

export default function Contacto() {
    return(
        <h1 className={s.h111}>Esto es Abouttt !!!!</h1>
    )
}